var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeliveryIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.53 7.27969V4.87969C11.53 3.11238 10.0973 1.67969 8.32998 1.67969C6.56267 1.67969 5.12998 3.11238 5.12998 4.87969V7.27969M1.60359 8.36126L1.12359 13.4813C0.987108 14.937 0.918869 15.6649 1.16042 16.2271C1.37262 16.721 1.74448 17.1293 2.2164 17.3867C2.7536 17.6797 3.48468 17.6797 4.94682 17.6797H11.7131C13.1753 17.6797 13.9064 17.6797 14.4436 17.3867C14.9155 17.1293 15.2873 16.721 15.4995 16.2271C15.7411 15.6649 15.6729 14.937 15.5364 13.4813L15.0564 8.36126C14.9411 7.13197 14.8835 6.51732 14.6071 6.05262C14.3636 5.64336 14.0039 5.31578 13.5736 5.11156C13.0852 4.87969 12.4678 4.87969 11.2331 4.87969L5.42682 4.87969C4.19214 4.87969 3.57479 4.87969 3.08632 5.11156C2.65612 5.31578 2.29639 5.64335 2.05291 6.05262C1.77646 6.51732 1.71883 7.13196 1.60359 8.36126Z",
    stroke: "#EB5B1E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveryIcon);
export default __webpack_public_path__ + "static/media/delivery-icon.24dd80a4d93e69189a7eb0f8f8f81b4e.svg";
export { ForwardRef as ReactComponent };